import { useT } from "../lib/LangContext";

export const KeyFacts = ({ facts, testId = "key-facts" }) => {
  const { t } = useT();
  if (!facts || facts.length === 0) return null;
  return (
    <div className="mt-3" data-testid={testId}>
      <div
        className="text-[11px] uppercase text-[#0AADA0] mb-1.5"
        style={{ letterSpacing: "0.08em" }}
      >
        {t("key_facts")}
      </div>
      <ul className="space-y-1.5 list-none m-0 p-0">
        {facts.map((f, i) => (
          <li
            key={i}
            className="flex items-start gap-2 text-[12px] text-[#6B7C82] leading-[1.55]"
            data-testid={`${testId}-item-${i}`}
          >
            <span
              className="inline-block w-[5px] h-[5px] rounded-full bg-[#0AADA0] mt-[7px] flex-shrink-0"
              aria-hidden="true"
            />
            <span>{f}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
